import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get, post } from "@insite/client-framework/Services/ApiService";
import { WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";

export interface customSaveForLaterApiParameter extends ApiParameter {
    wishListId: string;
    productId: string;
    qtyOrdered: number;
    unitOfMeasure: string;
    properties?: {
        name: string;
    };
    cartLineId: string;
    parameter: null | string;
    name: string;
    onSuccess?: (result: any) => void;
    onError?: () => void;
}

interface AddApiParameter {
    name: string;
    description: string;
}

const customSaveForLaterUrl = "/api/v1/wishlists";
const customeSaveForLaterV2Url = "/api/v2/wishlists";

export async function customGetWishListLines(
    parameter: customSaveForLaterApiParameter,
): Promise<ServiceResult<WishListLineModel>> {
    const { wishListId } = parameter;

    try {        
        const wishList = await post<WishListLineModel>(`${customSaveForLaterUrl}/${wishListId}/wishlistlines`, {
            productId: parameter.productId,
            qtyOrdered: parameter.qtyOrdered as number,
            unitOfMeasure: parameter.unitOfMeasure,
            properties: { name: "SAVEDITEM@#$" },
        } as any);
        return {
            result: wishList,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function addSaveForLaterWishlist(
    parameter: AddApiParameter,
): Promise<ServiceResult<WishListModel>> {
    try {
        const wishList = await post<WishListModel>(`${customSaveForLaterUrl}`, parameter as any);
        return {
            successful: true,
            result: wishList,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function customGetWishListLinesV2(
    parameter: customSaveForLaterApiParameter,
): Promise<ServiceResult<WishListLineModel>> {
    const { wishListId } = parameter;

    try {
        const wishList = await get<WishListLineModel>(`${customeSaveForLaterV2Url}/${wishListId}`, {
            parameter: parameter.parameter,
            name: parameter.name,
        } as any);
        return {
            result: wishList,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
